import React from "react"
import styles from "../css/App.module.css";
import classNames from "classnames";

interface Props {
    primary?: boolean,
    xl?: boolean
}

export default (props: Props) => {
    const {primary, xl} = props;
    return (
        <div className={classNames(styles.loader, {
            [styles.loaderPrimary]: primary,
            [styles.loaderXl]: xl,
        })}/>
    );

}
